<template>
  <f-modal-base
    closable
    @close="$emit('close')"
    backdrop-close
    :title2="$vt('Add domain')"
    :pending="pending"
  >
    <template #content>
      <div class="f-modal-text">
        {{ $vt('Every email addresses of the domain will be whitelisted') }}
      </div>
      <div class="f-modal-content-container">
        <f-icon class="f-modal-icon" icon="fa6-at"></f-icon>
        <f-textfield
          v-bind:input.sync="model.input"
          :placeholder="model.placeholder"
          v-on:enter="$emit('ok', model.input)"
          v-on:esc="$emit('close')"
        >
        </f-textfield>
      </div>
    </template>
    <template #actions>
      <f-button type="tertiary" v-on:click="$emit('close')">{{ $vt('Cancel') }}</f-button>
      <f-button
        type="primary"
        @click="$emit('ok', model.input)"
        :pending="pending"
        >{{ $vt('OK') }}</f-button
      >
    </template>
  </f-modal-base>
</template> 
<script>
export default {
  translate25Context: 'whitelist',
  data: function () {
    return {
      model: {
        input: "",
      },
    };
  },
  props: ["pending", "placeholder"],
  mounted() {},
  created() {
    this.model.input = this.placeholder;
  },
  watch: {
    placeholder() {
      this.model.input = this.placeholder;
    },
  },
};
</script>

<style lang="scss">
.f-modal-text {
  font-family: "Lato";
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  margin-bottom: 26px;
}

.f-modal-content-container {
  display: flex;
}

.f-modal-content-container .f-textfield {
  flex: 1 1 auto;
}

.f-modal-icon {
  font-size: 16px;
  margin-right: 6px;
  font-weight: bold;
  color: var(--blue);
}
</style>